//@flow

import moment from 'moment';
import { parse } from 'query-string';

/**
 *
 *  @param {number} monthUpto
 *  A function that returns the array of string containing(upto the param)
 *  month with year w.r.t present month
 *  @example getNextMonthsWithYears(2) => ['Dec 2018','Jan 2019']
 *  Note the date of writing this comment is November.
 *
 */

export default function getNextMonthsWithYears(monthUpto: number) {
  let nextMonthsWithYears = [];

  for (let nextMonth = 0; nextMonth < monthUpto; nextMonth++) {
    nextMonthsWithYears = [
      ...nextMonthsWithYears,
      moment()
        .add(nextMonth, 'months')
        .format('MMM YYYY'),
    ];
  }

  return nextMonthsWithYears;
}

export function activeClassNameFor(currentValue, selectedValue) {
  return currentValue === selectedValue ? 'active' : '';
}

export function validate(state, props) {
  const {
    step,
    dateRange,
    interestedRegions,
    trekType,
    services,
    selectedDateCondition,
  } = state;
  const { location } = props;

  if (step === 1) {
    // safety hatch if start date is included in the search queryparams
    // hence we can safely assume that user knows when to go
    const userHasStartDate = parse(location.search).start_date;

    if (userHasStartDate) {
      const dontAskForDates = false;
      return dontAskForDates;
    }

    const noSelectedDateCondition = !selectedDateCondition;
    const noTravelDates = selectedDateCondition === 'datePickr' && !dateRange;

    return noSelectedDateCondition || noTravelDates;
  }

  if (step === 2) {
    const noInterestedRegions = !interestedRegions;
    const noSelectedTrekType = !trekType;
    const noServicesWhenIndependentTrekSelected =
      trekType === 'independentTrek' ? !(services && services.length > 0) : false;

    return (
      noInterestedRegions || noSelectedTrekType || noServicesWhenIndependentTrekSelected
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/OnboardingForm/helpers.js